import React, { useState } from 'react';
import './navbar.css';
import { Link } from "react-router-dom"
import { Dropdown, Button, Modal } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

import Invia_mail_iniziale from './Progetto_x1_mail_iniziale';
import Preparazione_documenti from './Progetto_x3_preparazione_documenti';
import Preparazione_documenti_apprendistato from './Progetto_x4_preparazione_apprendistato';
import { AiOutlineMenuFold } from 'react-icons/ai';
import Valutazione_progetto from "./Progetto_valutazione_x0.jsx";

import Progetto_controllo_presenze from './Progetto_x2_presenze';
import Aggiungi_documentazione_attore from "../Funzioni_comuni_pdf_upload.jsx"; 

const funzione_esterna = require('../Funzioni_comuni_esterne')
//const { Controlla_se_lavoro_in_debug } = require('../Funzioni_comuni')


function check_variabili_oggetto(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj)
  }

function Controlla_se_lavoro_in_debug (user) {
    let debug = false
    let email_google = check_variabili_oggetto (user, 'email')  
      
        if (email_google === 'p.sordi@ipsiapacinotti.it' || 
            email_google === 'g.falcitelli@ipsiapacinotti.it' ||
            email_google === 'dirigente@ipsiapacinotti.it' ||
            email_google === 't.fogli@ipsiapacinotti.it') {
        }
        if (email_google === 'paolosordi12@gmail.com' ||
            email_google === 'dirigente@ipsiapacinotti.it' ||
            email_google === 't.fogli@ipsiapacinotti.it') {
              debug=true
        }
    
        return debug
    }

const Nuovo_Progetto_Edit = (props) => {
    const [somma, calcola_somma] = useState('');
    const [show_modifica, setShow_modifica] = useState(false);
    const [start_Date, set_Start_Date] = useState(new Date(props.progetto.data_inizio));
    const [end_Date, set_End_Date] = useState(new Date(props.progetto.data_fine));

    const [input, setInput] = useState({
        id_alunno: '',
        id_ditta: '',
        nome_alunno: '',
        nome_ditta: '',

        data_inizio: props.progetto.data_inizio,
        data_fine: props.progetto.data_fine,
        mattina: props.progetto.mattina,
        pomeriggio: props.progetto.pomeriggio
    });



    function handleClick1(event) {
        console.log('entrato');
        setShow_modifica(true);
    }

    function handleClick_modifica(event) {
        console.log('entrato modifica');
    }

    function handleChange(event) {
        const { name, value } = event.target;

        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        })
    }



    const handleClose = () => {
        setShow_modifica(false);
    }

    function handle_checkbox(event) {
        const { name, checked } = event.target;
        console.log('handle_change' + name + ' - ' + checked)
        console.log(event.target.name)
        console.log(event.target.value)
        console.log(event.target.checked)

        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: checked
            }
        })
    }


    function cancellazione_progetto(_id) {
        console.log(input);
        //        axios.post('http://localhost:3001/create', newNote)

        axios.delete('/progetti/cancella_progetto/' + props.progetto._id)
            .then((res) => {
                props.SET_variab_aggiorna(current => !current)
                console.log(props.lista_alunni)
                
                let lista_aux_progetti 
                lista_aux_progetti = props.lista_progetti.filter(item => item._id !== _id)
                console.log(lista_aux_progetti)

                funzione_esterna.Aggiorna_lista_alunni_per_semaforo_esterno(props.lista_alunni, lista_aux_progetti)
            }).catch((error) => {
                console.log(error)
            });
    }


    function progetto_da_mettere_in_pausa() {
        var valore = '1'
        if (props.progetto.progetto_attivo) {
            valore = '0'
        }
        axios.patch('/progetti/progetto_in_pausa/' + props.progetto._id + '/' + valore)
            .then((res) => {
                console.log(res.data)
            }).catch((error) => {
                console.log(error)
            });
        var aux = props.variab_aggiorna
        props.SET_variab_aggiorna(!aux)
    }



    return (
        <div class="d-flex flex-row-reverse">
            <Dropdown>
                <Dropdown.Toggle variant="Light" id="dropdown-basic">
                Menu  <AiOutlineMenuFold />
        </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Invia_mail_iniziale progetto={props.progetto} 
                                         SET_variab_aggiorna={props.SET_variab_aggiorna} tutor={props.tutor} />
                    <Preparazione_documenti progetto={props.progetto} tutor={props.tutor} variab_aggiorna={props.variab_aggiorna} SET_variab_aggiorna={props.SET_variab_aggiorna} />

                     {!Controlla_se_lavoro_in_debug &&
                    <Dropdown.Item onClick={handleClick1}>Modifica #DA FARE#</Dropdown.Item>}
                     <div class="dropdown-divider"></div>

                    <Progetto_controllo_presenze progetto={props.progetto} />
                    <Dropdown.Item as={Link} to={"/url_monitor_ditte?id=" + props.progetto._id}>Visualizza Foglio Firme</Dropdown.Item>
                    <Valutazione_progetto progetto={props.progetto}  />


                    <div class="dropdown-divider"></div>
                    <Dropdown.Item onClick={progetto_da_mettere_in_pausa}>Progetto in Pausa</Dropdown.Item>
      
                    <Dropdown.Item onClick={() => cancellazione_progetto(props.progetto._id)}>Cancella progetto</Dropdown.Item>
                    <Preparazione_documenti_apprendistato progetto={props.progetto} variab_aggiorna={props.variab_aggiorna} SET_variab_aggiorna={props.SET_variab_aggiorna} />
                    <div class="dropdown-divider"></div>
                  
                    {/*------------------ AGGIORNARE MONGO QRCODE ---------------------------*/}   
                    <Aggiungi_documentazione_attore attore_tipo ={'progetto'}  tipologia_documento={'Foglio_firme_giornaliero'} tutor={props.tutor} attore={props.progetto} SET_variab_aggiorna={props.SET_variab_aggiorna} />
                    <Aggiungi_documentazione_attore attore_tipo ={'progetto'}  tipologia_documento={'Valutazione_finale'} tutor={props.tutor} attore={props.progetto} SET_variab_aggiorna={props.SET_variab_aggiorna} />
       
                </Dropdown.Menu>
            </Dropdown>


            <Modal
                show={show_modifica}
                size="lg"
                onHide={handleClose}
                backdrop="static"
                keyboard={false}>
                <Modal.Dialog>
                    <Modal.Header closeButton>
                        <Modal.Title>Modal title</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <input onChange={handleChange} name="nome" value={input.nome} autoComplete="off" className="form-control"></input>
                        <div className='form-group'>
                            <input type="checkbox" name="mattina" checked={input.mattina} onChange={handle_checkbox}></input>
                            <label class="form-check-label" for="exampleCheck1">Mattine</label>
                            <input type="checkbox" name="pomeriggio" checked={input.pomeriggio} onChange={handle_checkbox}></input>
                            <label class="form-check-label" for="exampleCheck1">pomeriggi</label>
                        </div>

                        <p>
                            <label class="form-check-label" for="exampleCheck1">Data di inizio stage</label>
                            <DatePicker selected={start_Date} dateFormat="dd/MM/yyyy" onChange={(date) => set_Start_Date(date)} />
                        </p>
                        <p>
                            <label class="form-check-label" for="exampleCheck1">Data di fine stage</label>
                            <DatePicker selected={end_Date} dateFormat="dd/MM/yyyy" onChange={(date) => set_End_Date(date)} />
                        </p>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary">Close</Button>
                        <Button onClick={handleClick_modifica} variant="primary">Save changes</Button>
                    </Modal.Footer>
                </Modal.Dialog>
            </Modal>

        </div>
    )
}
export default Nuovo_Progetto_Edit;
